import { Component, OnInit } from '@angular/core';
import { CommonService } from "../../_services/common.service";
import {
  FormBuilder,
  FormGroup,
  Validators,
  FormArray,
  FormControl
} from "@angular/forms";

import { FlashMessagesService } from "angular2-flash-messages";
import { Router } from '@angular/router';
import { ConfirmationDialogComponent } from "../../shared/confirmation-dialog/confirmation-dialog.component";
import { MatDialog } from "@angular/material";

@Component({
  selector: 'app-update-card',
  templateUrl: './update-card.component.html',
  styleUrls: ['./update-card.component.css']
})
export class UpdateCardComponent implements OnInit {
  public total =100;
  public pagesToShow =10;
  public page = 1;
  public limit = 10;
  public startingAfter='';
  public end_before='';
  public updateCardForm: FormGroup;
  public loading = false;
  public activeClass = 'active';
  public subscriberOptions: any = {};
  public transactionList: Array<any> = [];
  public isShowpaging=false;  
  public enableprevious=false;  
  private nextCount=0;
  public userDetails:any={};
  expiryMonths: Array<any> = [
    { value: "", viewValue: "Month" },
    { value: "1", viewValue: "1" },
    { value: "2", viewValue: "2" },
    { value: "3", viewValue: "3" },
    { value: "4", viewValue: "4" },
    { value: "5", viewValue: "5" },
    { value: "6", viewValue: "6" },
    { value: "7", viewValue: "7" },
    { value: "8", viewValue: "8" },
    { value: "9", viewValue: "9" },
    { value: "10", viewValue: "10" },
    { value: "11", viewValue: "11" },
    { value: "12", viewValue: "12" }
  ];

  expiryYears: Array<any> = [
    { value: "", viewValue: "Year" },
  ];
  constructor(private formBuilder: FormBuilder,
    private _flashMessagesService: FlashMessagesService,
    private CommonService: CommonService,
    private router: Router,
    private dialog: MatDialog
    ) {
    this.updateCardForm = formBuilder.group({
      card_number: [null, Validators.required],
      expiry_month: ["", Validators.required],
      expiry_year: ["", Validators.required],
      card_cvv: [null, Validators.required]

    });
  }

  ngOnInit() {
  this.userDetails = JSON.parse(localStorage.getItem("userDetails"));
    this.getExpiryYears();
    this.getTransactionDetail();
  }

  isFieldValid(field: string) {
    return (
      !this.updateCardForm.get(field).valid &&
      this.updateCardForm.get(field).touched
    );
  }

  getExpiryYears() {
    var date = new Date();
    for (let currentYear = 0; currentYear < 10; currentYear++) {
      this.expiryYears.push(
        {
          value: date.getFullYear() + currentYear,
          viewValue: date.getFullYear() + currentYear
        });

    }
  }

  updateCardData = function (postData) {
    this.loading = true;
    if (this.updateCardForm.valid) {
      this.subscriberOptions = {
        id: localStorage.getItem("userID"),
        card_number: postData.card_number,
        card_expiry_month: postData.expiry_month,
        card_expiry_year: postData.expiry_year,
        card_cvv: postData.card_cvv,
        is_card_update:true
      };

      this.CommonService.apiService(
        "POST",
        "update/card",
        this.subscriberOptions
      ).subscribe(
        (response: any) => {
          this.loading = false;
          if (response.status === true) {
            this.updateCardForm.reset();
            this._flashMessagesService.show(response.message, {
              cssClass: "alert-success",
              timeout: 5000
            });
          }
          window.scrollTo(0, 0);
        },
        err => {
          this.loading = false;
          this._flashMessagesService.show(err.error.message, {
            cssClass: "alert-danger",
            timeout: 5000
          });
        }
      );

    }
    else {
      this.loading = false;
      this.validateAllFormFields(this.updateCardForm);
    }
  }

  validateAllFormFields(formGroup: FormGroup) {
    Object.keys(formGroup.controls).forEach(field => {
      const control = formGroup.get(field);
      if (control instanceof FormControl) {
        control.markAsTouched({ onlySelf: true });
      } else if (control instanceof FormGroup) {
        this.validateAllFormFields(control);
      }
    });
  }

  getTransactionDetail = function () {
    this.loading = true;
    this.subscriberOptions = {
      id:localStorage.getItem("userID"),
      shop_id:localStorage.getItem("userID"),
      starting_after:this.startingAfter,
      ending_before:this.end_before,
      limit: this.limit,
     
    };
   

    this.CommonService.apiService(
      "POST",
      "shop/invoices",
      this.subscriberOptions
    ).subscribe(
      (response: any) => {
        this.loading = false;
        if (response.status === true) {
          if (response.data) {               
            this.transactionList = response.data.records;  
            if(Object.keys(response.data.records).length>=10) 
            {
              this.isShowpaging=true;
            }
            else
            {
              this.isShowpaging=false;
            }           

          }
        }
      },
      err => {
        this.loading = false;
        console.log(err);
      }
    );
  };

  goToPage(n: number): void {    
    this.page = n;
    this.getTransactionDetail();
  }

  onNext(): void {   
    this.nextCount++
    this.enableprevious=true;
    this.startingAfter=this.transactionList[9].id;
    this.end_before='';
    this.page++;
    this.getTransactionDetail();
  }

  onPrev(): void { 
    
    this.end_before=this.transactionList[0].id;
    this.startingAfter='',
    this.page--;
    this.nextCount--;
    if(this.nextCount==0)
    {
      this.enableprevious=false;     
    }
    this.getTransactionDetail();
  }

  openUnSubscirbeDialog(): void {  
    const dialogRef = this.dialog.open(ConfirmationDialogComponent, {
      width: "250px",
      data: {
        name: this.userDetails.username,
        message: "Are you sure you want to Unsubscribe your plan",
        manageData: {
          dialogName:'UnSubscribe Plan'
        }
      }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        // window.open("https://theprintlife.freshdesk.com/support/tickets/new", "_blank");
        this.unSubscribe();
      }
    });  
}

unSubscribe = function () {
  this.loading=true;
  this.subscriberOptions = {
  };
  this.CommonService.apiService(
    "DELETE",
    "subscription/" + localStorage.getItem("userID"),
    this.subscriberOptions
  ).subscribe(
    (response: any) => {
      if (response.status === true) {
        this.loading=false;
        this._flashMessagesService.show("UnSubscriber successfully!", {
          cssClass: "alert-success",
          timeout: 5000
        });
        this.router.navigate(["/login"]);         
      }
    },
    err => {
      this.loading=false;
      this._flashMessagesService.show(err.error.message, {
        cssClass: "alert-danger",
        timeout: 5000
      });
    }
  );

}



}



// WEBPACK FOOTER //
// /var/www/login.theprintlife.com/src/app/mnt-users/update-card/update-card.component.ts